import { Button, Checkbox, Drawer, FormControlLabel, IconButton, Typography } from '@mui/material';
import PropTypes from 'prop-types';
// import { useboxActions } from 'src/context/providers/boxContext';
import { toast } from 'react-toastify';
import { useCustomerActions } from 'src/context/providers/CustomerContext';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import { useSettingsContext } from 'src/components/settings';
import { GZAVNILI_MODES } from 'src/components/settings/drawer/gzavnili-mode';
import CountrySelect from 'src/custom_components/CountrySelect/CountrySelect';
import { countryLabel } from 'src/utils/physical-api';
import InputFieds from '../../custom_components/Froms/InputFields';
import { billingFields, customerAddress, customerCreate, customerCreatePhysical } from './view/data';

const CreateboxDrawer = ({ isDrawerOpen, handleDrawerToggle }) => {
  const [boxData, setboxData] = useState({});
  const [userAddressInfo, setUserAddressInfo] = useState({});
  const [isSameAddress, setIsSameAddress] = useState(false);
  const [isNotResident, setIsNotResident] = useState(false);
  const [country, setCountry] = useState('');
  const isPhysical = useSettingsContext().gzavniliMode === GZAVNILI_MODES.physical;

  useEffect(() => {
    if (isSameAddress) {
      const copied = {
        billingAddress1: userAddressInfo.address1 || '',
        billingAddress2: userAddressInfo.address2 || '',
        billingState: userAddressInfo.state || '',
        billingCity: userAddressInfo.city || '',
        billingZipCode: userAddressInfo.zipCode || '',
      };
      setUserAddressInfo((prev) => ({ ...prev, ...copied }));
    }
  }, [isSameAddress, userAddressInfo]);

  const { createCustomer } = useCustomerActions();

  const Clear = () => {
    setboxData({});
    setUserAddressInfo({});
    setIsSameAddress(false);
    setIsNotResident(false);
    setCountry('');
  };

  const handleCreatebox = async () => {
    if (
      !boxData.first_name ||
      !boxData.last_name ||
      !boxData.email ||
      !boxData.phone ||
      !userAddressInfo.address1 ||
      !userAddressInfo.address2 ||
      (!isPhysical && !userAddressInfo.state) ||
      !userAddressInfo.city ||
      !userAddressInfo.zipCode ||
      !userAddressInfo.billingAddress1 ||
      !userAddressInfo.billingAddress2 ||
      (!isPhysical && !userAddressInfo.billingState) ||
      !userAddressInfo.billingCity ||
      !userAddressInfo.billingZipCode
    ) {
      toast.error('Please fill in all required fields');
      return;
    }
    if (
      isPhysical &&
      (!boxData.first_name_ka || !boxData.last_name_ka || !boxData.id_number)
    ) {
      toast.error('Georgian first/last name and Id Number are required');
      return;
    }
    if (isPhysical && !country) {
      toast.error('Select the sender country');
      return;
    }

    const customerData = {
      first_name: boxData.first_name,
      last_name: boxData.last_name,
      ...(isPhysical && {
        first_name_ka: boxData.first_name_ka,
        last_name_ka: boxData.last_name_ka,
        isNotResident,
        country,
      }),
      room_number: '',
      id_number: boxData.id_number,
      email: boxData.email,
      phone: boxData.phone,
      ...(isPhysical && { phone_secondary: boxData.phone_secondary }),
      marketing_permissions: true,
      isPhysicalUser: true,
    };
    await createCustomer(
      customerData,
      isPhysical ? { ...userAddressInfo, country: countryLabel(country) } : userAddressInfo
    );
    Clear();
    handleDrawerToggle();
  };

  const DrawerConfig = {
    SubNavigation: true,
    anchor: 'right',
    width: '40%',
    drawerHeaderText: 'Create Customer',
    buttons: {
      status: true,
      elements: [{ name: 'Create', onClick: handleCreatebox }],
    },
  };

  const containerStyle = {
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    position: 'fixed',
    zIndex: 2,
    top: 0,
    left: 0,
    display: isDrawerOpen ? 'block' : 'none',
    cursor: 'pointer',
  };

  const handleOutsideClick = (event) => {
    if (event.target === event.currentTarget) {
      handleDrawerToggle();
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      style={containerStyle}
      onKeyDown={(event) => {
        if (event.key === 'Escape') {
          handleDrawerToggle();
        }
      }}
      onClick={handleOutsideClick}
    >
      <Drawer
        variant="persistent"
        anchor={DrawerConfig.anchor}
        open={isDrawerOpen}
        onClose={handleDrawerToggle}
        PaperProps={{
          sx: { width: { lg: DrawerConfig.width, xs: '100%', md: '100%' } },
        }}
      >
        {/* Drawer Content */}

        {/* Header */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '16px',
            borderBottom: '1px solid rgba(220, 220, 220, 0.2)',
          }}
        >
          <Typography variant="h6">{DrawerConfig.drawerHeaderText}</Typography>

          <IconButton onClick={handleDrawerToggle}>
            <CloseIcon />
          </IconButton>
        </div>

        {/* Form */}
        <div
          className="content-wrap"
          style={{
            gap: '2px',
            padding: '0px 0px 0px 0px',
            alignItems: 'center',
            justifyContent: 'space-evenly',
          }}
        >
          <InputFieds
            userData={boxData}
            heading="User Information"
            inputFields={isPhysical ? customerCreatePhysical : customerCreate}
            setUserData={setboxData}
          />

          {isPhysical && (
            <div style={{ padding: '0 0 8px 20px' }}>
              <CountrySelect
                required
                value={country}
                onChange={setCountry}
                helperText="GE senders ship Georgia → USA, US senders ship USA → Georgia"
                sx={{ mb: 1 }}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isNotResident}
                    onChange={(e) => setIsNotResident(e.target.checked)}
                  />
                }
                label="Non-resident"
              />
            </div>
          )}

          <div>
            <InputFieds
              userData={userAddressInfo}
              heading="Shipping Address"
              inputFields={customerAddress}
              setUserData={setUserAddressInfo}
            />

            <div style={{ margin: '16px auto', width: '90%' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    id="sameAddressCheckbox"
                    checked={isSameAddress}
                    onChange={(e) => {
                      setIsSameAddress(e.target.checked);
                      setUserAddressInfo((prev) => ({
                        ...prev,
                        isBillingAndShippingSame: e.target.checked,
                      }));
                    }}
                  />
                }
                label="Billing and Shipping Address are the same"
              />
            </div>

            <InputFieds
              userData={userAddressInfo}
              heading="Billing Address"
              inputFields={billingFields}
              setUserData={setUserAddressInfo}
            />
          </div>
        </div>

        {/* Buttons */}
        {DrawerConfig.buttons && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              borderTop: '1px solid rgba(220, 220, 220, 0.2)',
              padding: '16px',
              bottom: '0',
              left: '0',
              width: '100%',
            }}
          >
            {DrawerConfig.buttons.elements.map((element, index) => (
              <Button
                variant="contained"
                key={index}
                style={{
                  marginLeft: '24px',
                  width: '136px',
                }}
                onClick={element.onClick}
              >
                Create
              </Button>
            ))}
          </div>
        )}
      </Drawer>
    </div>
  );
};

CreateboxDrawer.propTypes = {
  isDrawerOpen: PropTypes.bool.isRequired,
  handleDrawerToggle: PropTypes.func.isRequired,
};

export default CreateboxDrawer;
